import React from "react";

export default function Dice() {
  React.useEffect(() => {
    const button = document.getElementById("button-xuc-sac");

    button.addEventListener("click", () => {
      rollDice(button);
    });

    return () => {
      button.removeEventListener("click", () => {
        rollDice(button);
      });
    };
  });
  const sleep = (second) => {
    return new Promise((resolve) => setTimeout(resolve, second));
  };
  const rollDice = async (button) => {
    const dice = document.getElementById("dice-image");
    dice.classList.add("dice-shake");
    button.disabled = true;
    button.style.cursor = "no-drop";

    setTimeout(() => {
      dice.classList.remove("dice-shake");
      button.disabled = false;
      button.style.cursor = "pointer";
    }, 1000);

    await sleep(1000);
    let random = Math.floor(Math.random() * 6);

    if (random > 0) {
      dice.setAttribute("src", `/img/FriendsPlus/page29/E3/dice-${random}.png`);
    }
  };
  return <div>Dice</div>;
}
